import qs from 'qs';
import { network } from 'services/network';

export const refreshProgramAnalysisData = (params) => {
    const querystring = qs.stringify(
        { projectIDs: params.projectIDs, contractId: params.contractId },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/refreshProgramAnalysisData${querystring}`;
    return network.post(url).then((response) => response.data);
};
